import React, {Component} from 'react';
import {toast} from 'react-toastify';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';

import {GET_PERFORMANCE_REPORT} from "../../actions/ActionTypes";
import ErrorMsg from "../common/ErrorMsg";
import {downloadPDF} from "../common/Constants";
import loadingGIF from "../../public/assets/images/loading.gif";


export default class EvaluationModal extends Component {
    
    state = {
        compensationProfileList: [],
        compensationPeriodList: [],
        selectedPeriod: 0,
        isCompLoading: false,
        isPrintLoading: false,
        reviewDate: moment(),
        compensationPayments: [],
        selectedCompensationId: 0,
        performanceIncome: 0
    };

    remainingTotal = React.createRef();

    componentDidMount() {
        this.getUserCompensation();
    }

    getUserCompensation = async () => {
        try {
            let result = await this.props.getStaffCompensationList();
            if (result) {
                let compensationProfileList = result.map(profile => ({...profile}));
                this.setState({compensationProfileList}, () => {
                    if (this.props.staffDashboard.staffKPIList) {
                        let selectedCompensationId = this.props.staffDashboard.staffKPIList.compensation_profile_id;
                        this.setState({selectedCompensationId});
                        this.getCompensationPeriodList(selectedCompensationId);
                        this.getCompensationPayments(selectedCompensationId);
                        this.getCompensationIncomes(selectedCompensationId);
                    }
                });
            }            
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
    };

    compensationChangeHandler = (event) => {
        let selectedCompensationId = parseInt(event.currentTarget.value);
        if (selectedCompensationId > 0) {
            this.setState({
                selectedCompensationId,
                selectedPeriod: 0
            });
            this.getCompensationPeriodList(selectedCompensationId);
            this.getCompensationPayments(selectedCompensationId);
            this.getCompensationIncomes(selectedCompensationId);
        }
    };

    getCompensationIncomes = async (selectedCompensationId) => {
        if (selectedCompensationId > 0) {
            try {
                let result = await this.props.getCompensationIncomes(selectedCompensationId);
                if (result) {
                    let performanceIncome = result.performance_income;
                    this.setState({performanceIncome});
                }            
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    }

    getCompensationPayments = async (selectedCompensationId) => {
        if (selectedCompensationId > 0) {
            this.setState({isCompLoading: true});
            const {compensationPayments} = this.state;
            try {
                let result = await this.props.compensationPayments(selectedCompensationId, compensationPayments, "GET");
                if (result) {
                    let compensationPayments = result.map(payment => ({...payment}));
                    this.setState({compensationPayments});
                }            
            } catch (error) {
                console.log(error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
            this.setState({isCompLoading: false});
        }
    }

    getCompensationPeriodList = async (selectedCompensationId) => {
        this.setState({reviewDate: moment()});

        if (selectedCompensationId > 0) {
            try {
                let result = await this.props.getCompensationPeriodList(selectedCompensationId);
                if (result) {
                    let compensationPeriodList = result.map(period => ({...period}));
                    this.setState({compensationPeriodList});
                }            
            } catch (error) {
                console.log(error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    periodChangeHandler = (event) => {
        if (event.currentTarget.value > 0) {
            this.setState({selectedPeriod: parseInt(event.currentTarget.value)});
        }
    };

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleDateChange = (date) => {
        this.setState({reviewDate: date});
    };

    printReport = async () => {
        const {
            reviewDate, selectedCompensationId, selectedPeriod
        } = this.state;
        if (!selectedCompensationId) {
            toast.error("Please select a compensation profile.")
            return false;
        }
        if (selectedPeriod > 0) {
            let reviewDateStr = moment(reviewDate).format("YYYY-MM-DD");
            this.setState({isPrintLoading: true});
            try {
                let result = await this.props.ReportAction({
                    type: GET_PERFORMANCE_REPORT,  
                    compPeriodList: [selectedPeriod],
                    reviewDate: reviewDateStr, 
                });
                
                if (result) {
                    let content = result.content;
                    let fileName = result.file_name;
                    downloadPDF(content, fileName);
                }
            } catch (error) {
                console.log(error)
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
            this.setState({isPrintLoading: false});
        } else {
            toast.error("Please select period date range.");
        } 
    }

    render() {
        const {
            compensationProfileList, compensationPeriodList, selectedCompensationId,
            selectedPeriod, reviewDate, compensationPayments, performanceIncome,
            isPrintLoading
        } = this.state;

        let compensationListOption = compensationProfileList.map((profile, index) => 
            <option key={index} value={profile.id}>{profile.date_range}</option>
        );

        let compensationPeriodListOption = compensationPeriodList.map((period, index) => 
            <option key={index} value={period.id}>{period.date_range}</option>
        );

        let totalPaidPerformanceIncome = 0;
        let compensationPaymentDivs = compensationPayments.map((payment, index) => {
            totalPaidPerformanceIncome += payment.compensation_paid;
            return (<div key={index} className="col-6 col-sm-3 col-md-2 text-center mb-2">
                <label className="mb-1">{payment.month_name}</label>
                <NumberFormat type="tel" value={payment.compensation_paid} 
                    thousandSeparator={true} prefix={'$ '} allowNegative={false} 
                    className="form-control form-control-sm text-center" 
                    name="compensation_paid" disabled={true} 
                />
            </div>);
        });

        let remainingPerformanceIncome = performanceIncome - totalPaidPerformanceIncome;

        return (
            <Modal isOpen={this.props.modal} size="lg" toggle={this.props.toggleModal}>
                <ModalHeader toggle={this.props.toggleModal}>
                    Performance Evaluation Report
                </ModalHeader>
                <ModalBody className="bg-white">
                    <div className="w-block">
                        <div className="row">
                            <div className="col-sm-3 text-sm-right">
                                <label className="mb-0 pt-1">
                                    Compensation Profile:
                                </label>
                            </div>
                            <div className="col-sm-3">
                                <select name="user_name" className="form-control"
                                    onChange={this.compensationChangeHandler}
                                    value={selectedCompensationId}
                                >
                                    <option key="0" value={0}>
                                        Select Compensation Profile
                                    </option>
                                    {compensationListOption}
                                </select>
                            </div>
                            <div className="col-sm-6">
                                {this.state.isCompLoading && 
                                    <img src={loadingGIF} alt="loading..." 
                                        height="32" width="32" 
                                    /> 
                                }
                            </div>
                            <div className="col-sm-3 text-sm-right mt-2">
                                <label className="mb-0 pt-1">Date Range: </label>
                            </div>
                            <div className="col-sm-3 mt-2">
                                <select onChange={this.periodChangeHandler} 
                                    value={selectedPeriod} className="form-control"
                                >
                                    <option value={0}>Select Date Range</option>
                                    {compensationPeriodListOption}
                                </select>
                            </div>
                            <div className="col-sm-3 text-sm-right mt-2">
                                <label className="mb-0 pt-1">Review Date: </label>
                            </div>
                            <div className="col-sm-3 mt-2">
                                <div className="div-datepicker">
                                    <DatePicker
                                        selected={reviewDate}
                                        onChangeRaw={this.handleDateChangeRaw}
                                        onChange={(event) => this.handleDateChange(event)}
                                        dateFormat="MM-DD-YYYY"
                                        fixedHeight
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={moment('2012-01-01')}
                                        maxDate={moment().add(5, 'years')}
                                        autoComplete="off"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-block mt-3">
                        <div className="row">
                            <div className="col-sm-2 text-sm-right">
                                <label className="mb-0 pt-1">Total: </label>
                            </div>
                            <div className="col-sm-4">
                                <NumberFormat type="tel" value={performanceIncome} 
                                    thousandSeparator={true} prefix={'$ '} 
                                    className="form-control form-control-sm text-center" 
                                    disabled={true} 
                                />
                            </div>
                            <div className="col-sm-2 text-sm-right">
                                <label className="mb-0 pt-1">Remaining: </label>
                            </div>
                            <div className="col-sm-4">
                                <NumberFormat type="tel" 
                                    value={remainingPerformanceIncome} 
                                    thousandSeparator={true} prefix={'$ '} 
                                    className="form-control form-control-sm text-center" 
                                    disabled={true} ref={this.remainingTotal} 
                                />
                            </div>
                        </div>
                        <div className="row mt-3">{compensationPaymentDivs}</div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {isPrintLoading && 
                        <img src={loadingGIF} alt="loading..." height="32" width="32" /> 
                    }
                    <Button className='btn btn-success' 
                        onClick={this.printReport}
                        disabled={isPrintLoading}
                    >
                        Print
                    </Button>
                    <Button className='btn btn-secondary' 
                        onClick={this.props.toggleModal}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffDashboardNav/PerformanceEvaluationModal.js